import { createContext, useState } from 'react';

import {
  CareMatrixContextData,
  CareMatrixProviderProps,
  SessionInfo,
} from './types';

export const CareMatrixContextDefaultValues: CareMatrixContextData = {
  isModuleOpen: false,
  openModule: async () => Promise.resolve(),
  closeModule: () => null,
  patientCognitoId: '',
  sessionInfo: {} as SessionInfo,
};

export const CareMatrixContext = createContext(CareMatrixContextDefaultValues);

export function CareMatrixProvider({ children }: CareMatrixProviderProps) {
  const [isModuleOpen, setIsModuleOpen] = useState(false);
  const [patientCognitoId, setPatientCognitoId] = useState<string>('');
  const [sessionInfo, setSessionInfo] = useState<SessionInfo | undefined>();

  async function handleOpenModule(cognitoId: string, session?: SessionInfo) {
    setIsModuleOpen(true);

    setPatientCognitoId(cognitoId);

    if (session) {
      setSessionInfo(session);
    }
  }

  function handleCloseModule() {
    setIsModuleOpen(false);

    if (sessionInfo) {
      setSessionInfo(undefined);
    }
  }

  return (
    <CareMatrixContext.Provider
      value={{
        isModuleOpen,
        openModule: handleOpenModule,
        closeModule: handleCloseModule,
        patientCognitoId,
        sessionInfo,
      }}
    >
      {children}
    </CareMatrixContext.Provider>
  );
}
